var PdfPanel = {
    pdfBuilder: function(successHandler, errorHandler) {
        var bc = ub.current_material.settings;
        var stamp = moment(Date.now()).format();
        var client = ub.config.pageType === "Order Editor" ? ub.config.client_name : _input.order.client;
        var orderSetting = ub.config.order_data;
        OrderEditor.funcs.prepareSizingBreakDown();

        var _data = {
            "selectedSource": "Prolook Customizer",
            "selectedTemplate": "Prolook",
            "searchKey": "preview-" + ub.config.material_id + "-" + ub.config.item_id + "-" + stamp.replace(/[:+]/g, "-"),
            "thumbnails": bc.thumbnails,
            "category": bc.uniform_category,
            "fullName": "", // not used in any pdf service templates
            "client": client,
            "orderId": ub.config.orderCode,
            "foid": "",
            "description": typeof bc.material !== "undefined" ? bc.material.uniform_name : ub.config.uniform_name,
            "cutPdf": bc.cut_pdf,
            "stylesPdf": bc.styles_pdf,
            "roster": orderSetting.roster,
            "pipings": bc.pipings,
            "createdDate": moment(Date.now()).format('YYYY/MM/DD'),
            "notes": orderSetting.description,
            "sizeBreakdown": bc.size_breakdown,
            "applications": bc.applications,
            "sizingTable": bc.sizingTable,
            "upper": bc.upper,
            "lower": bc.lower,
            "hiddenBody": bc.hiddenBody,
            "randomFeeds": bc.randomFeeds,
            "legacyPDF": "", // display link if old pdf is generated
            "applicationType": ub.config.uniform_application_type,
            "sml": bc.sml,
            "sku": _.isEmpty(ub.current_material.material.sku) ? '-' : ub.current_material.material.sku,
            "priceItemCode": ub.config.priceItemCode,
            "gender": typeof bc.material !== "undefined" ? bc.material.gender : ub.config.gender,
            "approval": {
                "signature": typeof orderSetting.signatureUrl !== "undefined" ? orderSetting.signatureUrl : null,
                "dateTimeStamp": typeof orderSetting.signatureUrl !== "undefined" ?  moment(Date.now()).format('YYYY/MM/DD HH:mm:ss') : null,
                "disabled": typeof orderSetting.signatureUrl !== "undefined" ? false : true
            },
            // Additional Payload
            "prolookCartInfo": {
                // ub.config.blockPattern
                "cut_name": ub.config.blockPattern,
                // ub.config.option 
                "style_name": ub.config.option
            },
            "version": "2.5"
        };

        PdfPanel.postPdf(_data, successHandler, errorHandler);
    },

    pdfBuilderReversible: function(builderCustomizations, successHandler, errorHandler) {
        var stamp = moment(Date.now()).format();
        var orderSetting = window.parent.ub.config.order_data
        
        var data = {
            "type": "reversible",
            "filename": "prolook-reversible-testing-" + stamp.replace(/[:+]/g, "-"),
            "order_list": []
        }

        _.each(builderCustomizations, function(bc) {
            var material_id = typeof bc.settings.material !== "undefined" ? bc.settings.material.material_id : ""
            var order_item = {
                "index": bc.index,
                "data": {
                    "pdfGenerator": true,
                    "selectedSource": "Prolook Customizer",
                    "selectedTemplate": "Prolook",
                    "searchKey": "preview-" + material_id + "-" + bc.settings.item_id + "-" + stamp.replace(/[:+]/g, "-"),
                    "thumbnails": bc.settings.thumbnails,
                    "category": bc.settings.uniform_category,
                    "fullName": "",
                    "client": ub.config.client_name,
                    "salesRepEmail": "",
                    "orderId": ub.config.orderCode,
                    "foid": "",
                    "description": typeof bc.settings.material !== "undefined" ? bc.settings.material.uniform_name : "",
                    "cutPdf": bc.settings.cut_pdf,
                    "stylesPdf": bc.settings.styles_pdf,
                    "roster": orderSetting.roster,
                    "pipings": bc.settings.pipings,
                    "createdDate": moment(Date.now()).format('YYYY/MM/DD'),
                    "notes": orderSetting.description,
                    "sizeBreakdown": bc.settings.size_breakdown,
                    "applications": bc.settings.applications,
                    "sizingTable": "",
                    "upper": bc.settings.upper,
                    "lower": bc.settings.lower,
                    "hiddenBody": bc.settings.hiddenBody,
                    "randomFeeds": bc.settings.randomFeeds,
                    "legacyPDF": "",
                    "applicationType": typeof bc.settings.material !== "undefined" ? bc.settings.material.uniform_application_type : "",
                    "sml": bc.settings.sml,
                    "sku": "-",
                    "priceItemCode": bc.settings.priceItemCode,
                    "gender": typeof bc.settings.material !== "undefined" ? bc.settings.material.gender : "",
                    "approval": {
                        "signature": typeof orderSetting.signatureUrl !== "undefined" ? orderSetting.signatureUrl : null,
                        "dateTimeStamp": typeof orderSetting.signatureUrl !== "undefined" ? moment(Date.now()).format('YYYY/MM/DD HH:mm:ss') : null,
                        "disabled": typeof orderSetting.signatureUrl !== "undefined" ? false : true
                    },
                    // Additional Payload
                    "prolookCartInfo": {
                        // Block Pattern
                        "cut_name": typeof bc.settings.material !== "undefined" ? bc.settings.material.block_pattern : "",
                        "style_name": typeof bc.settings.material !== "undefined" ? bc.settings.material.option : ""
                    },
                    "version": "2.5"
                }
            }

            data.order_list.push(order_item);
        });

        PdfPanel.postPdf(data, successHandler, errorHandler);
    },

    postPdf: function(data, successHandler, errorHandler) {
        var url = "https://pdf-generator.prolook.com/api/upload";
        $.ajax({
            url: url,
            type: "POST",
            data: JSON.stringify(data),
            dataType: "json",
            crossDomain: true,
            contentType: 'application/json',
            headers: {
                "accessToken": null
            },
            success: successHandler,
            error: errorHandler
        });
    }
}